import { IAdditionalSettings } from "@/config/additionalSettings.config";

const greeceAdditionalSettingsConfig: IAdditionalSettings = {
  hasGoldenVisa: true,
  hasOSBB: true,
};

export default greeceAdditionalSettingsConfig;
